import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../../WebComponent'
import DetailRow from '../../../components/StaticDetailList/DetailRow'
import VerordnungMonitoringDto from "../VerordnungMonitoringDto";
import LinkCell from "@isceco/widget-library2/basic-elements/List/cell/LinkCell";
import StaticRow from "@isceco/widget-library2/basic-elements/List/StaticRow.js";
import UebersichtMonitoringColumns from "./UebersichtMonitoringColumns";
import VerordnungMonitoringService from "../VerordnungMonitoringService";
import UebersichtMonitoringPeriodeDto from "./UebersichtMonitoringPeriodeDto";

import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/List/StaticList'
import '../../../components/StaticDetailList/StaticDetailList'
import KontingentService from "../../../services/KontingentService";
import Navigation from "../../Navigation/Navigation";

export default class UebersichtMonitoringGp extends WebComponent {
  static get properties() {
    return {
      verordnung: {type: VerordnungMonitoringDto}
    }
  }

  constructor() {
    super()
    this.kontingentService = new KontingentService()
    this.verordnungService = new VerordnungMonitoringService()
  }

  get translationFile() {
    return './views/VerordnungMonitoring/Uebersicht/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.resolve(
      this.verordnungService.list(`${getNavigationId()}/perioden`)
    ).then(perioden => {
      this.perioden = perioden?.map(v => new UebersichtMonitoringPeriodeDto(v))
      this.render()
    })
  }

  getTemplate() {
    return html`
      <isceco-title size="medium" text="${this.i18n.translate('verordnungMonitoring.uebersicht.verordnung.title')}">
      </isceco-title>
      <eko-static-detail-list .data="${this.getVerordnungListData()}"></eko-static-detail-list>
      <isceco-title size="medium" text="${this.i18n.translate('verordnungMonitoring.uebersicht.perioden.title')}">
      </isceco-title>
      <isceco-static-list .i18n="${this.i18n}"
                          .rowurl="${this._toKontingentUrl}"
                          .rowVariant="${UebersichtMonitoringColumns.getCurrentPeriodeVariant()}"
                          .columns="${UebersichtMonitoringColumns.getGpColumns(this._downloadVerfuegung)}"
                          .data="${this.perioden?.map(periode => new StaticRow(periode))}"
      ></isceco-static-list>
    `
  }

  getVerordnungListData() {
    let verordnungLink = null
    if (this.verordnung.link) {
      const url = this.verordnung.link.indexOf(':') > 0 ? this.verordnung.link : `https://${this.verordnung.link}`
      verordnungLink = new LinkCell({ url: _ => url, target: '_blank', icon: 'external alternate' })
    }
    return [
      new DetailRow(this.i18n.translate('verordnungMonitoring.uebersicht.verordnung.srNummer'), this.verordnung.srNummer, verordnungLink),
      new DetailRow(this.i18n.translate('verordnungMonitoring.uebersicht.verordnung.art'), this.i18n.translate(this.verordnung.kontArt)),
      new DetailRow(this.i18n.translate('verordnungMonitoring.uebersicht.verordnung.geltungsdauerVon'), formatDate(this.verordnung.geltungsdauerVon)),
      new DetailRow(this.i18n.translate('verordnungMonitoring.uebersicht.verordnung.geltungsdauerBis'), formatDate(this.verordnung.geltungsdauerBis))
    ]
  }

  _toKontingentUrl = row => row.kontingentId ? constructURL({to: Navigation.ROUTES.monitoringKontingent.url, id: row.kontingentId}) : null

  _downloadVerfuegung = row => {
    const filename = `${this.verordnung.srNummer} - ${formatDate(row.start)}`
    this.kontingentService.read(row.kontingentId, 'pdf')
      .then(response => response.blob())
      .then(blob => download(toValidFilename(filename, 'pdf'), blob))
      .then(() => this.reload())
  }
}

customElements.define('eko-frontend-kontingentierung-uebersicht-gp', UebersichtMonitoringGp)
